const projects = [
    {
      name: "HappyHead",
      image: "/projects/HappyHead.png",
      about: "A gold award winning project focused on promoting happiness and well-being.",
      link: "https://happy-head-mental-health-companion.vercel.app/",
      github: "https://github.com/PotzarellaMozarella/HappyHead_Mental-Health-Companion",
    },
    {
      name: "Jammming",
      image: "/projects/Jammming.png",
      about: "A web application for creating and sharing music playlists.",
      link: "https://jamming-with-spotify-10gjn1xyr-potzarellamozarella.vercel.app/",
      github: "https://github.com/PotzarellaMozarella/Jamming-with-Spotify",
    },
    {
      name: "To-do list",
      image: "/projects/ToDoList.png",
      about: "A simple web app for managing tasks and to-do lists.",
      link: "https://pesto-projects-ovki.vercel.app/",
      github: "https://github.com/PotzarellaMozarella/Pesto-Projects/tree/master/Week-9/to-do-list",
    },
    {
      name: "URL shortener",
      image: "projects/UrlShortener.png",
      about: "A service for shortening long URLs to shareable links.",
      link: "https://smolurlshortener.netlify.app/",
      github: "https://github.com/PotzarellaMozarella/Pesto-Projects/tree/master/Week-10/urlshortener",
    },
    {
      name: "Weather app",
      image: "/projects/weatherapp.png",
      about: "A weather forecast application displaying real-time weather data.",
      link: "https://example.com/weatherapp",
      github: "https://github.com/PotzarellaMozarella/Pesto-Projects/tree/master/Week-13/weatherApp",
    },
    {
      name: "Wealth Management app",
      image: "",
      about: "An app for managing personal finances and investments.",
      link: "",
      github: "https://github.com/PotzarellaMozarella/Pesto-Projects/tree/master/Week-14/wealthapp",
    },
    {
        name: "Chrome-extension",
        image: "/projects/extension.png",
        about: "A Chrome extension for tracking and managing leads.",
        link: "",
        github: "https://github.com/PotzarellaMozarella/Lead-Tracker_Chrome-extension",
      },
      {
        name: "Form A Story",
        image: "/projects/story.png",
        about: "A project for creating interactive and collaborative stories.",
        link: "https://form-a-story-azure.vercel.app/",
        github: "https://github.com/PotzarellaMozarella/Form-A-Story-Project",
      },
      {
        name: "Piano Keys",
        image: "/projects/pianokeys.png",
        about: "An interactive web application for learning to play the piano.",
        link: "https://piano-keys.vercel.app/",
        github: "https://github.com/PotzarellaMozarella/Piano-Keys-Interactive-Game",
      },
      {
        name: "Blackjack game",
        image: "/projects/blackjack.png",
        about: "A virtual Blackjack card game implementation.",
        link: "https://black-jack-game-alpha.vercel.app/",
        github: "https://github.com/PotzarellaMozarella/BlackJack-Game",
      },
      {
        name: "Light switch",
        image: "/projects/Lightswitch.png",
        about: "A simple virtual light switch application with toggle functionality.",
        link: "https://fliplightswitch.netlify.app/",
        github: "https://github.com/PotzarellaMozarella/Pesto-Projects/tree/master/Week-11/lightswitch",
      },
      {
        name: "Steps counter",
        image: "/projects/stepCounter.png",
        about: "A step counter app to track and display the number of steps taken.",
        link: "https://stepcounterapp.netlify.app/",
        github: "https://github.com/PotzarellaMozarella/Pesto-Projects/tree/master/Week-11/stepcounter",
      },
  ];
  export default projects;
